// extracted by mini-css-extract-plugin
export var actionButton = "_7k-0";
export var attachmentLine = "_7k-1";
export var fileInput = "_7k-2";
export var fileUploadWrapper = "_7k-4";
export var footer = "_7k-3";
export var modalContent = "_7k-5";
export var paperclip = "_7k-6";
export var quillEditor = "_7k-7";